import { Button, Dialog, List, ListItem, StatusPill } from './ui'

/**
 * F-142 (REQ-293-001): finestra "dove e' usato" prima di disattivare un flusso o annullare una gara.
 * Stessa forma delle righe d'uso del catalogo (`CatalogUsageRow`): serve solo `label`, `count`, `blocking`
 * (il codice si chiama `code` per pipeline e gare, `area` per il catalogo, qui non serve). Mostra le righe con
 * conteggio maggiore di zero e chiede conferma; "Annulla" non fa nulla.
 */
export interface UsageRowLike {
  label: string
  count: number
  blocking: boolean
}

interface Props {
  title: string
  /** Frase sopra l'elenco, es. "Il flusso e' in uso." */
  message?: string
  usages: UsageRowLike[]
  confirmLabel?: string
  busy?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function UsageConfirmDialog({ title, message, usages, confirmLabel = 'Conferma', busy = false, onConfirm, onCancel }: Props) {
  const shown = usages.filter(u => u.count > 0)
  return (
    <Dialog
      open
      onClose={onCancel}
      title={title}
      supportingText={message}
      dismissible={!busy}
      actions={
        <>
          <Button variant="text" disabled={busy} onClick={onCancel}>Annulla</Button>
          <Button variant="text" tone="error" disabled={busy} onClick={onConfirm}>{confirmLabel}</Button>
        </>
      }
    >
      {shown.length === 0 ? (
        <p className="md-typescale-body-medium">Nessun uso registrato.</p>
      ) : (
        <div className="md-dialog__bleed">
          <List aria-label="Dove è usato" divided>
            {shown.map(u => (
              <ListItem
                key={u.label}
                headline={u.label}
                trailing={
                  <>
                    <span className="md-num">{u.count}</span>
                    {u.blocking ? <StatusPill tone="warning">Richiede conferma</StatusPill> : null}
                  </>
                }
              />
            ))}
          </List>
        </div>
      )}
    </Dialog>
  )
}
